import React, { useState, useEffect, useRef } from 'react';

import _blankImg from '../../assets/1x/Group 3466477.png';
import _blankImg2 from '../../assets/1x/files-and-folder.png';

import {
  ButtonNo,
  listBox,
  TooltipText,
  KnowledgeBaseContainerStyle,
  KnowledgeBaseMinStyle,
  KnowledgeBaseSearchStyle,
  KnowledgeBaseListBoxStyle,
  KnowledgeBaseListBox2Style,
  KnowledgeBaseListOneStyle,
  KnowledgeBaseListOne2Style,
  KnowledgeBaseBoxFootStyle,
  KnowledgeBaseModifyBoxStyle,
  KnowledgeBaseModifyBoxStyle2
} from '../styles/KnowledgeBase/KnowledgeBase.styles';
import { message, Tooltip } from 'antd';
import moment from 'moment';

// TODO: fix
//import 'antd/dist/antd.css';
require('../../styles/antd.css');

import {
  Stack,
  Text,
  TextField,
  IContextualMenuProps,
  DefaultButton,
  PrimaryButton,
  ChoiceGroup,
  IChoiceGroupOption,
  SearchBox,
  ISearchBoxStyles
} from '@fluentui/react';
//import _blankImg from '../../assets/1x/Group 3466477.png';
//import _blankImg2 from '../../assets/1x/files-and-folder.png';
// import { SearchBox, ISearchBoxStyles } from '@fluentui/react/lib/SearchBox';
import {
  DocumentCard,
  DocumentCardDetails,
  DocumentCardType
} from '@fluentui/react/lib/DocumentCard';
//import { authentication } from '@microsoft/teams-js';

import { apiServices } from '../../services/ApiServices';
import { Image } from '@fluentui/react/lib/Image';
import KnowledgeBaseDialog from './KnowledgeBaseDialog';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getIsAuthenticated } from '../../selectors/getIsAuthenticated';

const searchBoxStyles: Partial<ISearchBoxStyles> = { root: { width: 200, border: 'none', borderRadius: '4px' } };

const tooltipProps = (
  <div style={{ color: '#FFFFFF', borderRadius: '3px' }}>
    <p style={{ fontWeight: 600, fontSize: '12px', margin: '0px' }}>预设分类</p>
    <p style={{ fontWeight: 400, fontSize: '12px', margin: '0px' }}>该分类由管理员创建，仅管理员可编辑</p>
  </div>
);

let createdOn: NodeJS.Timeout;
export default function KnowledgeBase() {
  const [KnowledgeBaseDialogToggle, setKnowledgeBaseDialogToggle] = useState(false);
  const [KnowledgeBaseDialogInitial, setKnowledgeBaseDialogInitial] = useState(true);
  const [isNewCard, setIsNewCard] = useState(false);
  const [secondLevel, setSecondLevel] = useState(true);
  const [searchText, setSearchText] = useState('');
  const [tobig, setTobig] = useState(false);
  const [tag, setTag] = useState(-1);
  const [tag2, setTag2] = useState(-1);
  const createdRef = useRef<HTMLDivElement>(null);
  let list: any = [];
  let List2: any = [];
  const [DataList, setDataList] = useState(list);
  const [DataList2, setDataList2] = useState(List2);
  const [searchDataList, setSearchDataList] = useState(list);
  const [searchDataList2, setSearchDataList2] = useState(List2);
  const KnowledgeBaseEnd = useRef<HTMLDivElement>(null);
  let history = useHistory();
  const options: IChoiceGroupOption[] = [
    { key: '0', text: '仅自己可见', value: 0 },
    { key: '1', text: '全员可见', value: 1 }
  ];
  const menuProps: IContextualMenuProps = {
    items: [
      {
        key: 'emailMessage',
        text: '编辑',
        width: '5px',
        onClick: () => {
          if (secondLevel) {
            setNameValue(DataList[tag]?.name);
            setDescription(DataList[tag]?.description);
            setTobig(true);
          } else {
            setName2Value(DataList2[tag2]?.name);
            setItemContent(DataList2[tag2]?.itemContent);
            setIsEdit(true);
            setTobig(true);
          }
        }
      },
      {
        key: 'calendarEvent',
        text: '删除',
        onClick: (item) => {
          setKnowledgeBaseDialogInitial(false);
        }
      }
    ]
  };

  const acOnclick = (index: any) => {
    if (secondLevel) {
      setTag(index);
    } else {
      // 二级标签双击为编辑 加入开关
      setIsEdit(false);
      setTag2(index);
    }
  };
  const cancel = () => {
    if (secondLevel) {
      setNameValue('');
      setDescription('');
      setTag(-1);
    } else {
      if(isNewCard){
        setDataList2((s:any)=>{
          s.pop()
          return s
        })
      }
      setName2Value('');
      setItemContent('');
      // 二级标签双击为编辑 加入开关
      setIsEdit(false);
    }
    setTobig(false);
    setIsNewCard(false)
  };

  const returnToSuperior = async () => {
    if (!secondLevel) {
      setSecondLevel(true);
      setDataList2([]);
      setTag2(-1);
      // 打开编辑开关
      setIsEdit(false);
    }
  };
  const addList = async () => {
    setIsNewCard(true)
    clearTimeout(createdOn);
    createdOn = setTimeout(async () => {
      if (secondLevel) {
        //新建知识卡片（一级）
        let newCard = {
          name: '',
          description: '',
          ParentsId: '414A950B-2DBC-4BE7-AC4D-6BE1D270C7EC',
          OrderNumber: 1,
          visibleRange:0
        };
          let newList = JSON.parse(JSON.stringify(DataList));
          newList.push(newCard);
          setDataList(newList);
          setSearchDataList(newList);
          setTag(newList.length - 1);
          setNameValue(newCard?.name);
          setDescription(newCard?.description);
          setTobig(true);
    
      } else {
        //新建知识卡片（二级）

        let newCard = {
          CategoryId: DataList[tag].id,
          name: '',
          itemContent: '',
          OrderNumber: 1
        };
          let newList = JSON.parse(JSON.stringify(DataList2));
          newList.push(newCard);
          setDataList2(newList);
          setSearchDataList2(newList);
          itemClick(newList.length - 1);
          setTag2(newList.length - 1);
          setName2Value(newCard.name);
          setItemContent(newCard.itemContent);
          setIsEdit(true);
          setTobig(true);
      }
      BackToBottom();
    }, 1000);

  };
  const delCategroyOrItem = async () => {
    if (secondLevel) {
      if (tag !== -1 && DataList[tag]?.id) {
        let DelCategroy = await apiServices.DelCategroy(DataList[tag]?.id, isAdmin );
        let newList = JSON.parse(JSON.stringify(DataList));
        if (DelCategroy.result === true) {
          newList.splice(tag, 1);
          setDataList(newList);
          setSearchDataList(newList);
          message.success('删除成功');
        } else {
          message.error('删除失败');
        }
        setKnowledgeBaseDialogInitial(true);
      }
    } else {
      if (tag2 !== -1) {
        let DelItem = await apiServices.DelItem(DataList2[tag2]?.id, isAdmin );
        let newList2 = JSON.parse(JSON.stringify(DataList2));
        if (DelItem.result === true) {
          newList2.splice(tag2, 1);
          setDataList2(newList2);
          setSearchDataList2(newList2);
          message.success('删除成功');
        } else {
          message.error('删除失败');
        }
        setKnowledgeBaseDialogInitial(true);
      }
    }
  };

  const getCategroylist = async () => {
    const dataList = await apiServices.getCategroylist();
    if (dataList?.result) {
      dataList.result.unshift({
        name: '默认收藏夹',
        description: '请输入内容',
        ParentsId: '414A950B-2DBC-4BE7-AC4D-6BE1D270C7EC',
        orderNumber: 1,
        createAt:0,
        id: '00000000-0000-0000-0000-000000000000'
      });
      
      setDataList(dataList.result.sort( (a: any, b: any)=> {
        return  moment(a.createAt).valueOf()  - moment(b.createAt).valueOf() ;
      }));
      setSearchDataList(dataList.result);
    }
  };

  const modifyCategroy = async () => {
    if (secondLevel) {
      if(isNewCard){
        let newCard = {
          name: nameValue,
          description:description,
          ParentsId: '414A950B-2DBC-4BE7-AC4D-6BE1D270C7EC',
          OrderNumber: 1,
          visibleRange:visibleRange||0
        };
        const dataList = await apiServices.postCteatedCategroy(newCard, isAdmin);
        if (dataList.status == 0) {
          message.success('新建成功');
          let newList = JSON.parse(JSON.stringify(DataList));
          newList.pop()
          newList.push(dataList.result);
          setDataList(newList);
          setSearchDataList(newList);
          setTag(newList.length - 1);
          setNameValue(dataList.result?.name);
          setDescription(dataList.result?.description);
          setTobig(true);
        } else {
          message.error('新建失败');
        }
      }else{
        if (tag !== -1) {
          const it = JSON.parse(JSON.stringify(DataList[tag]));
          const list = JSON.parse(JSON.stringify(DataList));
  
          it.name = nameValue;
          it.description = description;
          visibleRange !==null && (it.visibleRange = visibleRange );
          let modifyCategroy = await apiServices.modifyCategroy(it, isAdmin );
  
          if (modifyCategroy.status === 0) {
            message.success({
              content: '修改成功'
            });
            list.splice(tag, 1, modifyCategroy.result);
            setDataList(list);
            setSearchDataList(list);
          } else {
            message.error('修改失败');
          }
          setNameValue('');
          setDescription('');      
          setTag(-1);
        }
      }
    } else {
      if(isNewCard){
        let newCard = {
          CategoryId: DataList[tag].id,
          name: name2Value,
          itemContent: itemContent,
          OrderNumber: 1,
          visibleRange:isAdmin?1:0
        };
  
        let dataList = await apiServices.postCteatedItem(newCard, isAdmin);
        if (dataList.status == 0) {
          message.success({
            content: '新建成功'
          });
          let newList = JSON.parse(JSON.stringify(DataList2));
          newList.splice(newList.length-1,1,dataList.result);
          setDataList2(()=>{
           return newList
          });
          setSearchDataList2(newList);
          itemClick(newList.length - 1);
          setTag2(newList.length - 1);
          setName2Value(newCard.name);
          setItemContent(newCard.itemContent);
          setIsEdit(true);
        } else {
          message.error('新建失败');
        }
      }else{
        if (tag2 !== -1) {
          const it = JSON.parse(JSON.stringify(DataList2[tag2]));
          const list = JSON.parse(JSON.stringify(DataList2));
          it.name = name2Value;
          it.itemContent = itemContent;
          let modifyItem =
            it.categoryId === '00000000-0000-0000-0000-000000000000'
              ? await apiServices.modifyItem(it, true)
              : await apiServices.modifyItem(it, isAdmin && DataList2[tag2].visibleRange == 1);
          if (modifyItem.status === 0) {
            message.success({
              content: '修改成功'
            });
            list.splice(tag2, 1, modifyItem.result);
            setDataList2(list);
            setSearchDataList2(list);
          } else {
            message.error('修改失败');
          }
          setName2Value('');
          setItemContent('');
          setIsEdit(false);
          setTag2(-1);
        }
      }
 
      await getItem(tag2);
    }
    setIsNewCard(false)
    setTobig(false);
  };
  // 一级卡片修改双向绑定
  const [nameValue, setNameValue] = React.useState('');
  const [visibleRange, setVisibleRange] = React.useState(null);
  const [description, setDescription] = React.useState('');
  const onChangeNameValue = React.useCallback(
    (event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, newValue?: string) => {
      setNameValue(newValue || '');
    },
    []
  );
  const onChangeDescription = React.useCallback(
    (event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, newValue?: string) => {
      setDescription(newValue || '');
    },
    []
  );
  const onChangeVisibleRange = (e: any, option: any) => {
    setVisibleRange(option.value);
  };

  // 二级卡片修改双向绑定
  const [isEdit, setIsEdit] = React.useState(false);
  const [name2Value, setName2Value] = React.useState('');
  const [itemContent, setItemContent] = React.useState('');
  const onChangeNameValue2 = React.useCallback(
    (event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, newValue?: string) => {
      setName2Value(newValue || '');
    },
    []
  );
  const onChangeDItemContent = React.useCallback(
    (event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, newValue?: string) => {
      setItemContent(newValue || '');
    },
    []
  );

  let cont = 0;
  const doubledac = (index: any,modifiable:boolean) => {
    cont += 1;
    setTimeout(() => {
      if (cont === 1) {
        getItem(index);
      } else if (cont === 2 && index !== 0 && modifiable) {
        setTag(index);
        if (!nameValue && !tobig) {
          setNameValue(DataList[index]?.name);
          setDescription(DataList[index]?.description);
        }
        setTobig(true);
      }
      cont = 0;
    }, 300);
  };

  const itemClick = (index2: number) => {
    setTag2(index2);
    // 打开编辑开关
    setIsEdit(true);
      setTobig(true);
        setName2Value(DataList2[index2]?.name);
        setItemContent(DataList2[index2]?.itemContent);
  };

  const getItem = async (index: number) => {
    acOnclick(index);
    if (index !== -1 && tobig == false) {
      let dataList2 = await apiServices.getItem(DataList[index]?.id);
      dataList2= dataList2.result.sort(function (a: any, b: any) {
        return  moment(a.createAt).valueOf()  - moment(b.createAt).valueOf() ;
      })       
      setDataList2(dataList2);
      setSearchDataList2(dataList2);
      setSecondLevel(false);
    }
  };
  //回到底部效果
  const BackToBottom = () => {
    if (KnowledgeBaseEnd && KnowledgeBaseEnd.current) {
      let height = KnowledgeBaseEnd.current.offsetTop; //计算需要向上移动的距离
      createdRef?.current?.scrollIntoView({
        block: 'end',
        behavior: 'smooth'
    });
    }
  };
  const [isAdmin, setIsAdmin] = React.useState(false);
  const [userId, setUserId] = React.useState('');
  const _onChange =async () => {
    let UserAgentStatusInfo = await apiServices.getUserAgentStatus();
    if (UserAgentStatusInfo) {
      if(typeof sessionStorage !== 'undefined'){
        sessionStorage.setItem('user', JSON.stringify(UserAgentStatusInfo?.result));
      }     
    }
    if(UserAgentStatusInfo?.result){
      let user =UserAgentStatusInfo?.result
      let userId = user.userId;
      setUserId(userId);
      if ((user && user.roleFlags & 2) === 2) {
        user.isAdmin = true;
        setIsAdmin(true);
      }
  
      if (!user.isAdmin === true) {
        let AdminList = DataList.filter((item: any) => {
          return item.ownerId === userId;
        });
        setDataList(AdminList);
      } else {
        getCategroylist();
      }
    }

  };
  // 搜索功能
  const searchList = async (value: String) => {
    if (value) {
      if (secondLevel) {
        //一级卡片搜索

        await setDataList((s: any) => {
          let newlist = searchDataList.filter((item: any) => {
            return (
              item.name.toLowerCase().indexOf(value.toLowerCase()) !== -1 ||
              item.description.toLowerCase().indexOf(value.toLowerCase()) !== -1
            );
          });

          return [...newlist];
        });
      } else {
        //二级卡片搜索
        await setDataList2((s: any) => {
          let newlist = searchDataList2.filter((item: any) => {
            return (
              item.name.toLowerCase().indexOf(value.toLowerCase()) !== -1 ||
              item.itemContent.toLowerCase().indexOf(value.toLowerCase()) !== -1
            );
          });
          return [...newlist];
        });
      }
    } else {
      onClearList();
    }
  };

  const onClearList = () => {
    if (secondLevel) {
      //一级卡片搜索
      getCategroylist();
    } else {
      //二级卡片搜索
      getItem(tag);
    }
  };

  const isAuthenticated = useSelector(getIsAuthenticated);
  useEffect(() => {
    if (isAuthenticated) {
      _onChange();
      getCategroylist();
    }
  }, [isAuthenticated]);

  return (
      <Stack grow className={KnowledgeBaseContainerStyle}>
        <div  className={KnowledgeBaseMinStyle}  ref={createdRef}>
        {tobig && (
          <div
            onClick={() => {
              cancel();
              getCategroylist();
            }}
            style={{
              width: '100%',
              height: '125%',
              position: 'absolute',
              left: 0,
              top: 0,
              backgroundColor: '#ccc',
              opacity: 0.5,
              zIndex: 2,
            }}
          ></div>
        )}

  <div className={KnowledgeBaseSearchStyle}>
            <div>
              {!secondLevel && (
                <div className="addBookmark">
                  <a onClick={returnToSuperior} style={{ color: '#000' }}>
                    {' '}
                    知识库{' '}
                  </a>{' '}
                  <span>{'>'}</span> <a style={{ color: '#000' }}> {DataList[tag].name}</a>
                </div>
              )}
            </div>
  
            <div style={{ display: 'flex' }}>
              <SearchBox
                styles={searchBoxStyles}
                placeholder="搜索"
                onEscape={(ev) => {
                  console.log('Custom onEscape Called');
                }}
                onClear={(ev) => {
                  onClearList();
                  setSearchText('')
                }}
                onChange={(_, newValue) => setSearchText(newValue||'')}
                onSearch={(newValue) => searchList(newValue)}
              />
              {( secondLevel || (isAdmin ||DataList[tag]?.ownerId===userId))  && <PrimaryButton
                style={{
                  width: '96px',
                  padding: '0px',
                  fontWeight: 600,
                  fontSize: '14px',
                  marginLeft: '12px'
                }}
                text={secondLevel ?"新建分类":"新建知识"}
                onClick={addList}
                allowDisabledFocus
              /> }
            </div>

          </div>
          <div style={{marginTop:"55px"}}>
          {secondLevel ? (
            <div className={KnowledgeBaseListBoxStyle} style={{ zIndex: 0 }}>
              {DataList.length === 0 ? (
                <div style={{ marginTop: '117px', display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
                  {' '}
                  <Image alt="未搜索到相关结果" style={{ maxWidth: '200px' }} src={_blankImg} />{' '}
                  <p style={{ fontWeight: 700, marginTop: '12px', fontSize: '18px' }}>未搜索到相关结果</p>
                </div>
              ) : null}
              <div className={listBox}>
                {DataList.map((item: any, index: number) => {
                  return (
                    <DocumentCard
                      onClick={() => {
                        doubledac(index,!(!isAdmin && item.ownerId !== userId));
                      }}
                      aria-label={item.description}
                      type={DocumentCardType.compact}
                      className={KnowledgeBaseListOneStyle}
                      style={index == tag && tobig ? { zIndex: 3} : {}}
                      key={index}
                    >
                      <div>
                      {index == tag && tobig && 
                        <div className={KnowledgeBaseModifyBoxStyle}>
                          <TextField
                            required={true}
                            label="名称"
                            value={nameValue}
                            placeholder='请输入分类名称'
                            onChange={onChangeNameValue}
                            className="modifyTop"
                            borderless={false}
                          />
                          <TextField
                            required={true}
                            resizable={false}
                            label="描述"
                            placeholder='请输入分类描述'
                            className="modifyBom"
                            value={description}
                            rows={5}
                            multiline
                            onChange={onChangeDescription}
                          />
                          {isAdmin && (
                            <div>
                              <ChoiceGroup
                                style={{ marginTop: '15px' }}
                                defaultSelectedKey={item.visibleRange + ''}
                                options={options}
                                onChange={onChangeVisibleRange}
                                label="可见范围"
                                required={true}
                              />
                            </div>
                          )}

                          <div style={{ marginTop: '10px' }}>
                            <PrimaryButton
                              style={{
                                width: '80px',
                                float: 'right',
                                fontWeight: 600,
                                fontSize: '14px',
                              }}
                              disabled={!nameValue || !description}
                              text="确定"
                              onClick={() => {
                                modifyCategroy();
                              }}
                            />
                            <DefaultButton
                              className={ButtonNo}
                              style={{ width: '80px', marginRight: '15px' }}
                              text="取消"
                              onClick={() => {
                                cancel();
                               getCategroylist();
                              }}
                            />
                          </div>
                        </div>}
                       
                        <DocumentCardDetails>
                          <Text style={{ fontWeight: 700, fontSize: '18px' }}>{item.name}</Text>
                          <Text style={{ height: '40px' }}>{item.description} </Text>
                          <div className={KnowledgeBaseBoxFootStyle}>
                            {(!isAdmin && item.ownerId !== userId) || index == 0 ? (
                              index !== 0 && (
                                <Tooltip placement="topLeft" title={tooltipProps} color="#5B5FC7">
                                  <Stack className={TooltipText}> 预设分类</Stack>
                                </Tooltip>
                              )
                            ) : (
                              <DefaultButton
                                className={ButtonNo}
                                style={{
                                  border: 'none',
                                  position: 'absolute',
                                  top: '0px',
                                  right: '0px',
                                  padding: '0px',
                                  width: '30px'
                                }}
                                text="..."
                                persistMenu
                                menuProps={menuProps}
                                onMenuClick={() => {
                                  acOnclick(index);
                                }}
                              />
                            )}
                          </div>
                        </DocumentCardDetails>
                      
                      </div>
                    </DocumentCard>
                  );
                })}
              </div>
              <div ref={KnowledgeBaseEnd} style={{ width: '100%', height: '1px' }}></div>
            </div>
          ) : (
            <div className={KnowledgeBaseListBox2Style}>
              {DataList2.length === 0 ? (
                <div style={{ marginTop: '117px', display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
                  {' '}
                  {searchText ?( <div style={{ display:"flex",alignItems:"center",justifyContent:"center"}}><Image style={{ maxWidth: '200px' }} src={_blankImg} />
                  <p style={{ fontWeight: 700, marginTop: '12px', fontSize: '18px' }}>未搜索到相关结果</p></div>) :(  <div style={{display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center"}}><Image style={{ maxWidth: '200px',marginRight:"14px" }} src={_blankImg2} />{' '}
                  <p style={{ fontWeight: 700, marginTop: '12px', fontSize: '18px' }}>
                    现在还没有内容，快来新建知识吧！
                  </p></div>)

                  }
                
                </div>
              ) : null}
              {DataList2.map((item: any, index2: number) => {
                return (
                  <div
                    key={index2}
                    className={KnowledgeBaseListOne2Style}
                    onDoubleClick={() => {
                      if(!isEdit &&(item.ownerId===userId || isAdmin)){
                        itemClick(index2);
                        }
                    }}
                    style={index2 == tag2 && isEdit ? { zIndex: 3} : {}}
                  >
                    {index2 === tag2 &&tobig&& isEdit ? (
                      <div className={KnowledgeBaseModifyBoxStyle2}>
                        <TextField
                          label="名称"
                          required={true}
                          placeholder="请输入知识标题"
                          value={name2Value}
                          onChange={onChangeNameValue2}
                          className="modifyTop"
                          borderless={false}
                        />
                        <TextField
                          label="描述"
                          required={true}
                          className="modifyBom"
                          placeholder="请编辑知识内容"
                          value={itemContent}
                          resizable={false}
                          multiline
                          onChange={onChangeDItemContent}
                        />
                        <div style={{ marginTop: '10px' }}>
                          <PrimaryButton
                            style={{ width: '80px', fontWeight: 600, fontSize: '14px' }}
                            text="确定"
                            disabled={!name2Value || !itemContent}
                            onClick={() => {
                           modifyCategroy();
                            }}
                          />
                          <DefaultButton
                            className={ButtonNo}
                            style={{ width: '80px', marginRight: '15px' }}
                            text="取消"
                            onClick={() => {
                              cancel();
                            }}
                          />
                        </div>
                      </div>
                    ) : (
                      <div>
                        <Text style={{ fontWeight: 700, fontSize: '18px' }}>{item.name}</Text>
                        <div>
                          {(item.ownerId===userId || isAdmin) &&    <DefaultButton
                            className={ButtonNo}
                            style={{ border: 'none',    top: '-43px',right: '-15px' }}
                            text="..."
                            persistMenu
                            menuProps={menuProps}
                            onMenuClick={() => {
                              acOnclick(index2)
                            }}
                          /> }
                        </div>
                        {/* </div> */}
                        <div className="BaseListOneBom">
                          <Text style={{ whiteSpace: 'pre-wrap' }}>{item.itemContent} </Text>
                        </div>
                      </div>
                    )}
                  </div>
                );
              })}
              <div ref={KnowledgeBaseEnd} style={{ width: '100%', height: '1px' }}></div>
            </div>
          )}
  </div>
          <KnowledgeBaseDialog
            toggle={KnowledgeBaseDialogToggle}
            initial={KnowledgeBaseDialogInitial}
            delCategroy={delCategroyOrItem}
            changeInitial={setKnowledgeBaseDialogInitial}
          />
        </div>

      </Stack>

  );
}
